import * as joi from "joi";

export type { ValidationResult } from "joi";

export const sensorDataSchema = joi.object().keys({
    sensorId: joi.string().required(),
    locationId: joi.number().required().min(1),
    sensorType: joi.string().min(1).required(),
    storage: joi.bool().required(),
});

export const virtualSensorDataSchema = joi.object().keys({
    sensorId: joi.string().required(),
    locationId: joi.number().required().min(1),
    sensorType: joi.string().min(1).required(),
    storage: joi.bool().required(),
    heartbeatMonitoringIntervalTimeInMinutes: joi
        .number()
        .min(5)
        .max(1440)
        .allow(null),
});
